export const STANDARD_STALE_TIME = {
  short: 10000, // 10 sec
  long: 300000, // 5 minutes
  permanent: Infinity,
};

export const STANDARD_CACHE_TIME = {
  short: 600000, // 10 minutes
  long: 86400000, // 1 day
  permanent: Infinity,
};

export const STANDARD_REFETCH_INTERVAL = {
  short: 5000, // 5 seconds
  medium: 60000, // 1 minute
  long: 300000, // 5 minutes
};
